import axios from 'axios';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';


const RegisterHotel = () => {
    const Navigate = useNavigate();
    const path = useLocation();
    const [initialValues] = useState({ name: "", password: "", username: "", age: "", number: "", confirm_password: "", gender: "" })
    const [Pwd, setPwd] = useState(false);

    const userRegister = useFormik({
        initialValues,
        // validationSchema: RegisterSchema,
        onSubmit: (values,{ resetForm }) => {


            axios.post(`${process.env.REACT_APP_URL}/auth/register`, values)
                .then(res => {
                    if (res.status === 200) {

                        localStorage.setItem('is_loading', "true");
                        toast.success("Hotel Registerd SuccessFully!");
                        resetForm();
                        Navigate('/register');
                    }
                })
                .catch(err => {
                    toast.error(err.response.data.msg)
                });

        },
    });


    useEffect(() => {
        // Create a new <link> element
        const linkElement = document.createElement('link');
        linkElement.rel = 'stylesheet';
        linkElement.type = 'text/css';
        linkElement.href = window.location.origin + '/assets/css/authentication/form-2.css';

        // Append the <link> element to the <head> tag
        document.head.appendChild(linkElement);

        // Clean up the <link> element when the component unmounts
        return () => {
            document.head.removeChild(linkElement);
        };
    }, [path]);

    return (
        <>
            <section className="vh-100">
                <div className="container h-100">
                    <div className="row d-flex justify-content-center align-items-center h-100">
                        <div className="col-lg-12 col-xl-11">
                            <div className="card text-black" >
                                <div className="card-body p-md-5">
                                    <div className="row justify-content-center">
                                        <div className="col-md-10 col-lg-6 col-xl-5 order-2 order-lg-1">

                                            <p className="text-center h1 fw-bold mb-5 mx-1 mx-md-4 mt-4">Sign up</p>
                                            <form onSubmit={userRegister.handleSubmit}>
                                                <div className="d-flex flex-row align-items-center mb-4">
                                                    <i className="fas fa-user fa-lg me-3 fa-fw"></i>
                                                    <div className="form-outline flex-fill mb-0">
                                                        <label>Username</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="Enter Username"
                                                            value={userRegister.values.username}
                                                            onChange={userRegister.handleChange}
                                                            onBlur={userRegister.handleBlur}
                                                            name="username"
                                                        />
                                                    </div>
                                                    {userRegister.errors.username && userRegister.touched.username ? (
                                                        <h6 className="text-danger mt-2 ml-1">
                                                            {userRegister.errors.username}
                                                        </h6>
                                                    ) : null}
                                                </div>

                                                <div className="d-flex flex-row align-items-center mb-4">
                                                    <i className="fas fa-user fa-lg me-3 fa-fw"></i>
                                                    <div className="form-outline flex-fill mb-0">
                                                        <label>Name</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="Enter Name"
                                                            value={userRegister.values.name}
                                                            onChange={userRegister.handleChange}
                                                            onBlur={userRegister.handleBlur}
                                                            name="name"
                                                        />
                                                    </div>
                                                    {userRegister.errors.name && userRegister.touched.name ? (
                                                        <h6 className="text-danger mt-2 ml-1">
                                                            {userRegister.errors.name}
                                                        </h6>
                                                    ) : null}
                                                </div>
                                                <div className="d-flex flex-row align-items-center mb-4">
                                                    <i className="fas fa-user fa-lg me-3 fa-fw"></i>
                                                    <div className="form-outline flex-fill mb-0">
                                                        <label>Age</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="Enter Age"
                                                            value={userRegister.values.age}
                                                            onChange={userRegister.handleChange}
                                                            onBlur={userRegister.handleBlur}
                                                            name="age"
                                                        />
                                                    </div>
                                                    {userRegister.errors.age && userRegister.touched.age ? (
                                                        <h6 className="text-danger mt-2 ml-1">
                                                            {userRegister.errors.age}
                                                        </h6>
                                                    ) : null}
                                                </div>
                                                <div className="d-flex flex-row align-items-center mb-4">
                                                    <i className="fas fa-user fa-lg me-3 fa-fw"></i>
                                                    <div className="form-outline flex-fill mb-0">
                                                        <label>Contact Number</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="Enter Contact Number"
                                                            value={userRegister.values.number}
                                                            onChange={userRegister.handleChange}
                                                            onBlur={userRegister.handleBlur}
                                                            name="number"
                                                        />
                                                    </div>
                                                    {userRegister.errors.number && userRegister.touched.number ? (
                                                        <h6 className="text-danger mt-2 ml-1">
                                                            {userRegister.errors.number}
                                                        </h6>
                                                    ) : null}
                                                </div>

                                                {/* <div className="d-flex flex-row align-items-center mb-4">
                                                    <i className="fas fa-envelope fa-lg me-3 fa-fw"></i>
                                                    <div className="form-outline flex-fill mb-0">
                                                        <label>Hotel Address</label>
                                                        <input
                                                            id="gender"
                                                            name="text"
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Hotel Address"
                                                            value={userRegister.values.gender}
                                                            onChange={userRegister.handleChange}
                                                            onBlur={userRegister.handleBlur}
                                                            autoComplete="gender"
                                                        />
                                                    </div>
                                                    {userRegister.errors.gender && userRegister.touched.gender ? (
                                                        <h6 className="text-danger mt-2 ml-1">
                                                            {userRegister.errors.gender}
                                                        </h6>
                                                    ) : null}
                                                </div> */}

                                                <div className="d-flex flex-row align-items-center mb-4">
                                                    <i className="fas fa-user fa-lg me-3 fa-fw"></i>
                                                    <div className="form-outline flex-fill mb-0">
                                                        <label>Gender</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="Enter Hotel Address"
                                                            value={userRegister.values.gender}
                                                            onChange={userRegister.handleChange}
                                                            onBlur={userRegister.handleBlur}
                                                            name="gender"
                                                        />
                                                    </div>
                                                    {userRegister.errors.gender && userRegister.touched.gender ? (
                                                        <h6 className="text-danger mt-2 ml-1">
                                                            {userRegister.errors.gender}
                                                        </h6>
                                                    ) : null}
                                                </div>

                                                <div className="d-flex flex-row align-items-center mb-4">
                                                    <i className="fas fa-lock fa-lg me-3 fa-fw"></i>
                                                    <div className="form-outline flex-fill mb-0">
                                                        <label>Password</label>
                                                        <input
                                                            id="password"
                                                            name="password"
                                                            type={Pwd ? "text" : "password"}
                                                            className="form-control"
                                                            placeholder="Enter Password"
                                                            value={userRegister.values.password}
                                                            onChange={userRegister.handleChange}
                                                            onBlur={userRegister.handleBlur}
                                                            autoComplete="current-password"
                                                        />
                                                    </div>
                                                    {userRegister.errors.password && userRegister.touched.password ? (
                                                        <h6 className="text-danger mt-2 ml-1">
                                                            {userRegister.errors.password}
                                                        </h6>
                                                    ) : null}
                                                </div>

                                                <div className="d-flex flex-row align-items-center mb-4">
                                                    <i className="fas fa-key fa-lg me-3 fa-fw"></i>
                                                    <div className="form-outline flex-fill mb-0">
                                                        <label>Confirm Password</label>
                                                        <input
                                                            id="password"
                                                            name="confirm_password"
                                                            type={Pwd ? "text" : "password"}
                                                            className="form-control"
                                                            placeholder="Enter Confirm Password"
                                                            value={userRegister.values.confirm_password}
                                                            onChange={userRegister.handleChange}
                                                            onBlur={userRegister.handleBlur}
                                                            autoComplete="current-password"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-start">
                                                    <button type="submit" className="btn btn-primary btn-lg">Register</button>
                                                    <button type="button" onClick={() => Navigate('/user/login')} className="btn btn-primary btn-lg ml-3">Sign In</button>
                                                </div>
                                                {/* <div className="d-flex justify-content-end">
                                                    <button type="button" className="btn btn-primary btn-lg">Register</button>
                                                </div> */}
                                            </form>

                                        </div>
                                        <div className="col-md-10 col-lg-6 col-xl-7 d-flex align-items-center order-1 order-lg-2">

                                            <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/draw1.webp"
                                                className="img-fluid" alt="Sample image" />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default RegisterHotel